import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook
import { useAuth } from "./Auth/AuthContext"; // Import the useAuth hook

const Logout = () => {
  const { logout } = useAuth(); // Get the logout function from context
  const navigate = useNavigate(); // Get the navigate function from react-router-dom

  useEffect(() => {
    // Call the logout function to clear authentication state
    logout();

    // Redirect to the login page after logging out
    navigate("/", { replace: true });
  }, [logout, navigate]);

  return <div>Logging out...</div>;
};

export default Logout;
